import { dsClass } from '../../common/constants/dsClasses.js';
import { formatProductOfferingPrice } from '../../common/utils/priceUtilsCoCo.js';
import {
  getLocalizedString,
  getProductOfferingPriceDataWithFallback,
} from '../../common/utils/productOfferingsUtils.js';
import { ProductOfferingPrice } from '../../generated/api/productOfferingPrice.js';
import type { BundleAddonGroup } from '../../generated/api/bundleAddonGroup.js';

import './InstallationServiceSelectorCoCo.scss';

export interface InstallationServiceSelectorCoCoProps {
  group: BundleAddonGroup;
  selectedOfferingIds: string[];
  onSelectionChange: (groupId: string, selectedIds: string[]) => void;
  errorMessage?: string;
}

export const InstallationServiceSelectorCoCo = ({
  group,
  selectedOfferingIds,
  onSelectionChange,
  errorMessage,
}: InstallationServiceSelectorCoCoProps) => {
  const offerings = group.productOffering ?? [];
  const groupName = getLocalizedString(group.name);
  const radioGroupName = `installation-service-group-${group.id}`;

  if (offerings.length === 0) {
    return null;
  }

  return (
    <div className="of-installation-service-selector">
      <div className="of-installation-service-selector__subheading">{groupName}</div>
      <fieldset className="of-installation-service-selector__fieldset" role="radiogroup" aria-label={groupName}>
        {offerings.map(offering => {
          const isSelected = selectedOfferingIds.includes(offering.id);
          const offeringName = getLocalizedString(offering.name);
          return (
            <div
              key={offering.id}
              className={`of-installation-service-selector__item ${
                isSelected ? 'of-installation-service-selector__item--selected' : ''
              }`}
            >
              <div className="ds-radio">
                <input
                  type="radio"
                  id={`${radioGroupName}-${offering.id}`}
                  name={radioGroupName}
                  value={offering.id}
                  checked={isSelected}
                  onChange={() => onSelectionChange(group.id, [offering.id])}
                />
                <label className="ds-radio__label" htmlFor={`${radioGroupName}-${offering.id}`}>
                  <span className="ds-radio__icon" />
                  <span className="of-installation-service-selector__name">{offeringName}</span>
                  <span className="of-installation-service-selector__price">
                    {formatProductOfferingPrice(
                      getProductOfferingPriceDataWithFallback(
                        offering.productOfferingPrice,
                        ProductOfferingPrice.PriceTypeEnum.OC,
                        ProductOfferingPrice.PriceTypeEnum.RC
                      )
                    )}
                  </span>
                </label>
              </div>
            </div>
          );
        })}
      </fieldset>
      {errorMessage && (
        <div className={`${dsClass.TEXT_XS} ${dsClass.MARGIN_TOP_1} ${dsClass.TEXT_COLOR_ERROR}`}>{errorMessage}</div>
      )}
    </div>
  );
};
